import { DeliveryPartner, Funder, ProgrammeFamily } from '@formrails/shared/util-models';
import { DeliveryPartnerDto } from '../dtos/Responses/deliveryPartnerDto';
import { FunderDto } from '../dtos/Responses/funderDto';
import { ProgrammeFamilyDto } from '../dtos/Responses/programmeFamilyDto';

export function fromFunderDto(dto: FunderDto): Funder {
  return {
    id: dto.id,
    code: dto.code,
    name: dto.name,
    description: dto.description,
    imageName: dto.logoUrl,
    defaultDeliveryPartnerId: dto.defaultDeliveryPartnerId,
    deleted: dto.deleted
  };
}

export function fromDeliveryPartnerDto(dto: DeliveryPartnerDto): DeliveryPartner {
  return {
    id: dto.id,
    code: dto.code,
    name: dto.name,
    description: dto.description,
    funders: dto.funders ?? [],
    imageName: dto.logoUrl,
    order: dto.order,
    deleted: dto.deleted
  };
}

export function fromProgrammeFamilyDto(dto: ProgrammeFamilyDto): ProgrammeFamily {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    funders: dto.funders ?? [],
    disallowedApplicantEmailDomains: dto.disallowedApplicantEmailDomains ?? [],
    deleted: dto.deleted
  };
}
